import api from './client';

// Open Banking (TrueLayer) API
export const openbankingAPI = {
  getInstitutions: () => api.get('/integrations/openbanking/institutions'),
  connect: (institutionId, origin) => api.post('/integrations/openbanking/connect', null, {
    params: { institution_id: institutionId, origin },
  }),
  getStatus: () => api.get('/integrations/openbanking/status'),
  sync: (connectionId) => connectionId
    ? api.post(`/integrations/openbanking/sync/${connectionId}`)
    : api.post('/integrations/openbanking/sync'),
  disconnect: (connectionId) => api.delete(`/integrations/openbanking/disconnect/${connectionId}`),
  reconnect: (connectionId, origin) => api.post(`/integrations/openbanking/reconnect/${connectionId}`, null, {
    params: { origin },
  }),
  getDiagnostics: () => api.get('/integrations/openbanking/diagnostics'),
  // Ambiguous-provider picker (Commit 3): persists the operator's pick so
  // every future connect/reconnect for this institution resolves immediately.
  setProviderChoice: (institutionId, providerId) =>
    api.post('/integrations/openbanking/provider-choice', { institution_id: institutionId, provider_id: providerId }),
  // "Change provider": undoes a wrong pick (e.g. RBS resolved to Bankline
  // when the operator needs RBS Digital Banking) so the next connect/
  // reconnect re-prompts the picker instead of reusing the stored choice.
  clearProviderChoice: (institutionId) =>
    api.delete(`/integrations/openbanking/provider-choice/${institutionId}`),
};
